import { useEffect, useRef, useState } from "react";
import { Bell } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { api } from "../lib/api";

export const NotificationsBell = () => {
  const [items, setItems] = useState([]);
  const seen = useRef(null);

  useEffect(() => {
    const load = () =>
      api.get("/notifications").then((r) => {
        const unread = r.data.filter((n) => !n.read);
        if (seen.current) unread.filter((n) => !seen.current.has(n.id)).forEach((n) => { toast(n.message); navigator.vibrate?.(200); });
        seen.current = new Set(r.data.map((n) => n.id));
        setItems(r.data);
      }).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);

  const unread = items.filter((n) => !n.read).length;
  const onOpen = (open) => {
    if (open && unread) {
      api.post("/notifications/read").then(() => setItems((xs) => xs.map((n) => ({ ...n, read: true }))));
    }
  };

  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notifications-button" className="relative h-10 w-10 grid place-items-center rounded-full text-stone-300 hover:bg-stone-800 hover:text-white transition-colors">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span data-testid="notifications-unread-count" className="absolute top-1 right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#E0533C] text-[10px] font-bold grid place-items-center text-white">
              {unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 z-[1100] bg-stone-900 border-stone-700 p-0">
        <div className="px-4 py-3 border-b border-stone-800 font-display font-bold">Notifiche</div>
        <ul data-testid="notifications-list" className="max-h-80 overflow-auto divide-y divide-stone-800">
          {items.length === 0 && <li className="px-4 py-6 text-sm text-stone-500">Nessuna notifica</li>}
          {items.map((n) => (
            <li key={n.id} className={`px-4 py-3 text-sm ${n.read ? "text-stone-400" : "text-stone-100"}`}>
              <p>{n.message}</p>
              <p className="text-[11px] text-stone-500 mt-1">{new Date(n.created_at).toLocaleString("it-IT")}</p>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
};
